import { render, staticRenderFns } from "./PlatformAlertBanner.vue?vue&type=template&id=6267fcc2&scoped=true&"
import script from "./PlatformAlertBanner.vue?vue&type=script&lang=js&"
export * from "./PlatformAlertBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAlertBanner.vue?vue&type=style&index=0&id=6267fcc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267fcc2",
  null
  
)

export default component.exports